import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

export const ServerSuccessesWrapper = styled(Box)`
  max-width: 420px;

  ${({ theme }) => css`
    padding: 1.2rem;
    background-color: ${theme.colors.primaryLightAdd2};
    text-align: center;
    @media (min-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.fontSizes.p3};
    }
    p {
      margin-bottom: ${theme.spacing(1)};

      &:last-child {
        margin-bottom: 0;
      }
    }
  `}
`;
